import { motion } from "framer-motion";
import React from "react";

export interface SvgPathProps extends Omit<React.SVGAttributes<SVGElement>, "points" | "path"> {
	path: [x: number, y: number][];
	points?: [cx: number, cy: number][];
	boxSize: [h: number, w: number];
	color: string;
	transitionDelay?: number;
}

export const SvgPath: React.FC<SvgPathProps> = ({ path, points, boxSize, color, transitionDelay, ...htmlProps }) => {
	const stringPath = `M ${path[0][0]} ${path[0][1]} ${path
		.slice(1)
		.map(([x, y]) => `L ${x} ${y}`)
		.join(" ")}`;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${boxSize.join(" ")}`} {...htmlProps}>
			<defs>
				<filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
					<feDropShadow dx="0" dy="0" stdDeviation="2" floodColor={color} floodOpacity="1" />
				</filter>
			</defs>
			<motion.path
				fill="none"
				d={stringPath}
				stroke={color}
				initial={{ pathLength: 0 }}
				animate={{ pathLength: 1 }}
				transition={{
					pathLength: { duration: 1, ease: "easeInOut", delay: transitionDelay },
				}}
			/>

			{points?.map(([cx, cy], i) => (
				<motion.circle
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{
						delay: (1 / points.length) * i,
					}}
					fill={color}
					key={i}
					cx={cx}
					cy={cy}
					r={5}
					filter="url(#shadow)"
				></motion.circle>
			))}
		</svg>
	);
};
